var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"zelan-tabbar"},_vm._l((_vm.tabList),function(tab){return _c('div',{key:tab.id,class:[
			'zelan-tabbar__item zelan-tabbar__item--' + tab.id,
			{
				'zelan-tabbar__item--active': tab.id === _vm.activeId
			}
		],on:{"click":function($event){return _vm.clickTab(tab)}}},[_c('p',[_vm._v(_vm._s(tab.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }